module.exports = __webpack_public_path__ + "view-blue.svg?1c0545fa46f2db8b13accb3194c6488e";